module.exports = __webpack_public_path__ + "static/img/3122_phase_function_Paper_Points.eabbf3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3122_phase_function_Paper_Points.png
// module id = Iqfy
// module chunks = 0